import { useConversation } from "../Stores/Conversation";
import { useInvitation } from "../Stores/Invitation";
import { useUserStore } from "../Stores/User";

export function getChinUsers({
    profiles,
    all_profile_ids,
    selected_profile_ids,
}) {
    return all_profile_ids
        .map((profile_id) =>
            profiles.find((profile) => profile.id == profile_id),
        )
        .filter((profile) => profile && !profile.is_agent)
        .map(({ id, full_name, avatar_url, is_active, is_agent }) => ({
            id,
            name: full_name,
            disabled: !selected_profile_ids.includes(id),
            imageSrc: avatar_url,
            is_association_ended: !is_active,
            is_agent: is_agent,
        }))
        .filter((user) => user.id);
}

/**
 * @param {{
 *   selected_entities: object[];
 *   resource_type?: string | null;
 * }} params
 * @param {boolean} [is_conversation]
 * @returns {Promise<{ selected_ids: number[]; profile_ids: number[] }>}
 */
export async function fetchChinProfileIdsFromInviteApi(
    { selected_entities, resource_type = null },
    is_conversation = false,
) {
    let profile_ids = [];
    let selected_ids = [];

    try {
        const responses = await Promise.all(
            selected_entities
                .filter((entity) => entity)
                .map((entity) => {
                    const resolvedResourceType =
                        resource_type ??
                        useInvitation().RESOURCE_TYPES[entity.entity_type];

                    return axios.get(
                        `/invites/chin/${resolvedResourceType}/${entity?.type_id ?? entity?.id}`,
                    );
                }),
        );
        profile_ids = responses
            .flatMap((response) => [...response.data?.data.all_profile_ids])
            .filter((e, i, a) => a.indexOf(e) === i);

        selected_ids = responses.flatMap((response) =>
            response.data?.data?.has_conversation
                ? [...response.data?.data.participants]
                : [...response.data?.data.invited_profile_ids],
        );

        if (is_conversation) {
            selected_entities.forEach((entity) => {
                const conv = useConversation().getConversationByTypeAndTypeId(
                    entity?.type ?? entity?.entity_type,
                    entity?.type_id ?? entity?.id,
                );
                if (conv) {
                    selected_ids = [
                        ...selected_ids,
                        ...conv.getActiveParticipats().map((item) => item.id),
                    ];
                }
            });
        }
        selected_ids = selected_ids.filter(
            (item, pos) => selected_ids.indexOf(item) === pos,
        );
    } catch (error) {
        console.log(`Error - invite api`, error);
    }

    return { selected_ids, profile_ids };
}

/**
 * @param {{
 *   selected_entities: object[];
 *   resource_type?: string | null;
 * }} params
 * @param {boolean} [is_conversation]
 * @returns {Promise<object[]>}
 */
export async function fetchChinUsersFromInviteApi(params, is_conversation = false) {
    const { selected_ids, profile_ids } = await fetchChinProfileIdsFromInviteApi(
        params,
        is_conversation,
    );

    return getChinUsers({
        profiles: useUserStore().profiles,
        all_profile_ids: profile_ids,
        selected_profile_ids: selected_ids,
    });
}

export async function handleInviteApi(
    { selected_entities, update_store },
    is_conversation = false,
    resource_type = null,
) {
    const { selected_ids, profile_ids } = await fetchChinProfileIdsFromInviteApi(
        { selected_entities, resource_type },
        is_conversation,
    );

    update_store(selected_ids, profile_ids);
}
